export default "__VITE_ASSET__D_FQ3CYF__"